import {
    LOADING_TOGGLE_ACTION,
    COMPANY_KYC_LIST_INITIATED,
    COMPANY_KYC_INITIATED,
    COMPANY_KYC_LIST_LOADED,
    COMPANY_KYC_LOADED,
    COMPANY_KYC_FAILED,
    COMPANY_KYC_CREATED,
    COMPANY_KYC_UPDATED,
    COMPANY_KYC_DELETED,
    KYC_MASTERS_LOADED,
    CLEAR_CURRENT_COMPANY_KYC,
    CLEAR_ERRORS,
    SET_CURRENT_PAGE,
    SET_FILTERS
} from '../actions/CompanyKycActions';

const initialState = {
    listdata: [],
    data: {},
    kycMasters: [],
    loading: false,
    listLoading: false,
    error: null,
    pagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        pageSize: 10,
        hasNext: false,
        hasPrevious: false
    },
    filters: {},
    success: false
};

function CompanyKycReducer(state = initialState, action) {
    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
            };

        case COMPANY_KYC_LIST_INITIATED:
            return {
                ...state,
                listLoading: true,
                error: null
            };

        case COMPANY_KYC_INITIATED:
            return {
                ...state,
                loading: true,
                error: null
            };

        case COMPANY_KYC_LIST_LOADED:
            return {
                ...state,
                listdata: action.payload.data || [],
                pagination: {
                    totalRecords: action.payload.pagination?.totalRecords || 0,
                    totalPages: action.payload.pagination?.totalPages || 1,
                    currentPage: action.payload.pagination?.currentPage || 1,
                    pageSize: action.payload.pagination?.limit || 10,
                    hasNext: action.payload.pagination?.hasNext || false,
                    hasPrevious: action.payload.pagination?.hasPrevious || false
                },
                listLoading: false,
                error: null,
                success: true
            };

        case COMPANY_KYC_LOADED:
            return {
                ...state,
                data: action.payload || {},
                loading: false,
                error: null,
                success: true
            };

        case COMPANY_KYC_FAILED:
            return {
                ...state,
                loading: false,
                listLoading: false,
                error: action.payload,
                success: false
            };

        case COMPANY_KYC_CREATED:
            return {
                ...state,
                data: action.payload || {},
                loading: false,
                error: null,
                success: true
            };

        case COMPANY_KYC_UPDATED:
            return {
                ...state,
                data: action.payload || {},
                listdata: state.listdata.map(item =>
                    item.id === action.payload?.id ? action.payload : item
                ),
                loading: false,
                error: null,
                success: true
            };

        case COMPANY_KYC_DELETED:
            return {
                ...state,
                listdata: state.listdata.filter(item => item.id !== action.payload),
                loading: false,
                error: null,
                success: true
            };

        case KYC_MASTERS_LOADED:
            return {
                ...state,
                kycMasters: action.payload || [],
                loading: false,
                error: null,
                success: true
            };

        case CLEAR_CURRENT_COMPANY_KYC:
            return {
                ...state,
                data: {},
                error: null,
                success: false
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        case SET_CURRENT_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    currentPage: action.payload
                }
            };

        case SET_FILTERS:
            return {
                ...state,
                filters: action.payload
            };

        default:
            return state;
    }
}

export default CompanyKycReducer;